import axios from 'axios';
import _ from 'lodash';
import { getMultisiteAccessQuery, getUsersQuery, getProducersQuery, getHaulingCompaniesQuery, getProcessorsQuery, getProducerBusinessesQuery } from './queries';
import { buildExpressQuery } from './queries/builders';
import { renameKey } from '../../utils';

const getAccessList = (id, role, filterInactive = false) =>
    new Promise((resolve, reject) => {
        if (role === 'admin') {
            const fields = ['id', 'name', 'role', 'license_number', 'hauler_number', 'status'];
            const producersQuery = getProducersQuery({ filterDeleted: true, filterInactive, fields, queryBuilder: buildExpressQuery });
            const processorsQuery = getProcessorsQuery({ filterDeleted: true, filterInactive, fields, queryBuilder: buildExpressQuery });
            const haulingCompaniesQuery = getHaulingCompaniesQuery({ filterDeleted: true, filterInactive, fields, queryBuilder: buildExpressQuery });
            const producerBusinessQuery = getProducerBusinessesQuery({ filterDeleted: true, filterInactive, fields, queryBuilder: buildExpressQuery });

            const producersRequest = axios.get(producersQuery);
            const processorsRequest = axios.get(processorsQuery);
            const haulingCompaniesRequest = axios.get(haulingCompaniesQuery);
            const producerBusinessRequest = axios.get(producerBusinessQuery);

            const requests = [producersRequest, processorsRequest, haulingCompaniesRequest, producerBusinessRequest];

            axios
                .all(requests)
                .then(
                    axios.spread((...responses) => {
                        const [producersResponse, processorsResponse, haulingCompaniesResponse, producerBusinessResponse] = responses;
                        const users = _.sortBy([...producersResponse.data, ...processorsResponse.data, ...haulingCompaniesResponse.data, ...producerBusinessResponse.data], 'name');
                        renameKey(users, '_id', 'id');
                        const data = _.map(users, (user) => ({
                            id: user.id,
                            label: user.name,
                            type: user.role,
                            license_number: user.license_number,
                            hauler_number: user.hauler_number,
                            status: user.status,
                        }));
                        resolve({ accesses: data });
                    })
                )
                .catch((errors) => {
                    // eslint-disable-next-line no-console
                    console.log(errors);
                    reject(new Error('User credentials are not correct'));
                });
        } else {
            const accessQuery = getMultisiteAccessQuery({ id });
            const accessRequest = axios.get(accessQuery);

            accessRequest
                .then((accessResponse) => {
                    const accesses = accessResponse.data;
                    const accessIds = _.uniq(_.flatten(_.map(accesses, 'access_id')));

                    const userQuery = getUsersQuery({ ids: accessIds, fields: ['id', 'name', 'role', 'license_number', 'hauler_number', 'status'], queryBuilder: buildExpressQuery });
                    const userRequest = axios.get(userQuery);

                    userRequest.then((userResponse) => {
                        const users = userResponse.data;
                        renameKey(users, '_id', 'id');
                        const data = _.map(users, (user) => ({
                            id: user.id,
                            label: user.name,
                            type: user.role,
                            license_number: user.license_number,
                            hauler_number: user.hauler_number,
                            status: user.status,
                        }));
                        resolve({ accesses: data });
                    });
                })
                .catch((errors) => {
                    // eslint-disable-next-line no-console
                    console.log(errors);
                    reject(new Error('User credentials are not correct'));
                });
        }
    });

export default getAccessList;
